import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Grid, Panel } from 'rsuite'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import FormDownLoadsTable from '../../widgets/formDownloads/FormDownLoadsTable'
import { doneLoading, startLoading } from '../../utils/loading'
import { getDownloadFormSchema } from '../../redux/actions/formDownloads'

export default function FormDownloads() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getDownloadFormSchema()

      if (response) {
        response.formDownloads.map((group) => {
          if (group.files.length > 0) {
            group.files.map((file, index) => {
              console.log('file => ', file)

              // เพิ่ม key object no = index + 1 เอาไปใช้ filter
              file.no = index + 1

              // ต้องเอาเครื่องหมายออก match file ไม่ได้
              let str1 = file.documentName.replaceAll(' ', '_')
              let str2 = str1.replaceAll('-', '')
              let str3 = str2.replaceAll('(', '_')
              let str4 = str3.replaceAll(')', '')
              let str5 = str4.replaceAll('__', '')
              let str6 = str5.replaceAll('..', '.')

              file.documentName = str6
            })
          }
        })

        setSchema(response)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {/* <Grid className="page-home"> */}
      <div className="custom-dashboard">
        <TopLevelNav />
        {/* <PageToolbar /> */}

        <ContentHeader header={schema?.header || ''} subHeader={schema?.subHeader || ''} />

        {schema?.formDownloads?.length > 0 &&
          schema?.formDownloads.map((item, index) => {
            return (
              <Panel
                shaded
                header={item?.title || ''}
                collapsible
                defaultExpanded
                style={{ marginBottom: 20 }}
                key={index}
              >
                <FormDownLoadsTable
                  hiddenDepartment={item?.title == 'ดาวน์โหลดแบบฟอร์ม สำนักกฎหมาย'}
                  schema={item?.files}
                  key={index}
                />
              </Panel>
            )
          })}
      </div>
      {/* </Grid> */}
    </>
  )
}

const mockSchema = {
  header: 'ดาวน์โหลดแบบฟอร์ม',
  subHeader: '',
  formDownloads: [
    {
      title: 'หลักฐานประกอบการยื่นข้อเสนอโครงการ',
      files: [
        {
          id: '',
          no: '1',
          documentName: 'บุคคลธรรมดา',
          department: '',
          lastUpdate: ' 28 กุมภาพันธ์ 2566',
          fileSize: '13 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '2',
          documentName: 'คณะบุคคลหรือห้างหุ้นส่วนที่ไม่ใช่นิติบุคคล',
          department: '',
          lastUpdate: ' 28 กุมภาพันธ์ 2566',
          fileSize: '14 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '3',
          documentName: 'บริษัทหรือห้างหุ้นส่วนนิติบุคคล',
          department: '',
          lastUpdate: ' 28 กุมภาพันธ์ 2566',
          fileSize: '14 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '4',
          documentName: 'มูลนิธิหรือสมาคม',
          department: '',
          lastUpdate: ' 28 กุมภาพันธ์ 2566',
          fileSize: '14 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '5',
          documentName: 'ส่วนราชการหรือหน่วยงานอื่นของรัฐ',
          department: '',
          lastUpdate: ' 28 กุมภาพันธ์ 2566',
          fileSize: '14 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
      ],
    },
    {
      title: 'ดาวน์โหลดคู่มือ',
      files: [
        {
          id: '',
          no: '1',
          documentName: 'Quick Guide -สำหรับผู้รับทุน V.1.2',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '3.3 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '2',
          documentName: 'Quick Guide -สำหรับนักวิชาการสำนัก V.1.2',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '3.5 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '3',
          documentName: 'Quick Guide -ศูนย์สัญญา  V 1.0',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '981 KB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '4',
          documentName: 'Quick Guide - สำหรับผู้ทรงคุณวุฒิ V 1.2',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '1 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '5',
          documentName: 'Quick Guide - ผู้มีอำนาจอนุมัติ  V 1.0',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '1.3 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '6',
          documentName: 'Quick Guide - การจัดการโครงการย่อย V 1.0',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '4.8 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '7',
          documentName: 'คู่มือการใช้งานระบบบริหารงานโครงการ(E-Granting) - สำหรับภาคี V.1.3',
          department: '',
          lastUpdate: ' 01 กรกฎาคม 2565',
          fileSize: '6.2 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '8',
          documentName: 'คู่มือการใช้งานระบบบริหารงานโครงการ(E-Granting) - สำหรับเจ้าหน้าที่ V.1.5',
          department: '',
          lastUpdate: ' 04 กรกฎาคม 2565',
          fileSize: '17.8 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '9',
          documentName: 'แก้ไขสัญญาในระบบeGranting(งบประมาณ)',
          department: '',
          lastUpdate: ' 09 ธันวาคม 2565',
          fileSize: '845 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '10',
          documentName: 'แก้ไขสัญญาในระบบeGranting(ระยะเวลา)',
          department: '',
          lastUpdate: ' 09 ธันวาคม 2565',
          fileSize: '678 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '11',
          documentName: 'วิธีการปรับแก้ไขระยะเวลา(ขอแก้ไขสัญญา)_นักวิชาการ',
          department: '',
          lastUpdate: ' 13 กุมภาพันธ์ 2566',
          fileSize: '262 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '12',
          documentName: 'Manual_ฉบับปรับปรุงการใช้ระบบ_update_วันที่_15052566',
          department: '',
          lastUpdate: ' 14 มิถุนายน 2566',
          fileSize: '262 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '13',
          documentName: 'คู่มือการกดอนุมัติหลายโครงการในระบบ_eGranting',
          department: '',
          lastUpdate: ' 14 มิถุนายน 2566',
          fileSize: '1183 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '14',
          documentName: 'คู่มืองานกฎหมาย',
          department: '',
          lastUpdate: ' 2 ตุลาคม 2566',
          fileSize: '2.5 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '15',
          documentName: 'คู่มือฉบับย่อสำหรับการจัดการบันทึกรับจ่าย',
          department: '',
          lastUpdate: ' 2 ตุลาคม 2566',
          fileSize: '4.3 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '16',
          documentName: 'คู่มือฉบับย่อสำหรับครุภัณฑ์หมุนเวียน',
          department: '',
          lastUpdate: ' 2 ตุลาคม 2566',
          fileSize: '2.6 MB',
          fileType: 'pdf',
          filePath: '',
          link: '',
          icon: {
            name: 'file-pdf-o',
            color: '#ee0d0d',
          },
        },
      ],
    },
    {
      title: 'สื่อการสอน (Multimedia Files)',
      files: [
        {
          id: '',
          no: '1',
          documentName: 'ผู้ทรงคุณวุฒิ',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '35.6 MB',
          fileType: 'mp4',
          filePath: '',
          link: 'https://drive.google.com/file/d/1oPqEAsMF485y-jkWMTP4xcMBjC8PQzI6/view?usp=sharing',
          icon: {
            name: 'youtube-play',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '2',
          documentName: 'ภาคีผู้รับทุน',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '183.9 MB',
          fileType: 'mp4',
          filePath: '',
          link: 'https://drive.google.com/file/d/1j5VLJRyYn4cN_K5c5EyyJ7HCUCfL0mx5/view?usp=sharing',
          icon: {
            name: 'youtube-play',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '3',
          documentName: 'ศูนย์สัญญา',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '45.4 MB',
          fileType: 'mp4',
          filePath: '',
          link: 'https://drive.google.com/file/d/1KKA7ec671HvqUU_Wf_OJ39uAdWop7hGW/view?usp=sharing',
          icon: {
            name: 'youtube-play',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '4',
          documentName: 'นักวิชาการ-ผู้ประสาน',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '177.7 MB',
          fileType: 'mp4',
          filePath: '',
          link: 'https://drive.google.com/file/d/1fyhU18hLdDXA8xZBqPaZtiLTKQBuqy9K/view?usp=sharing',
          icon: {
            name: 'youtube-play',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '5',
          documentName: 'ผู้มีอำนาจอนุมัติ',
          department: '',
          lastUpdate: ' 11 พฤษภาคม 2565',
          fileSize: '97.7 MB',
          fileType: 'mp4',
          filePath: '',
          link: 'https://drive.google.com/file/d/1uyfvh9ncMWx51FihAlYgmqKSeItOmK8v/view?usp=sharing',
          icon: {
            name: 'youtube-play',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '6',
          documentName: 'ระบบสารสนเทศเพื่อการบริหารงานโครงการ (E-Granting)',
          department: '',
          lastUpdate: ' 21 กันยายน 2565',
          fileSize: '549 MB',
          fileType: 'mp4',
          filePath: '',
          link: 'https://www.youtube.com/watch?v=G8E_MMv7b8w',
          icon: {
            name: 'youtube-play',
            color: '#ee0d0d',
          },
        },
        {
          id: '',
          no: '7',
          documentName: 'ระบบสารสนเทศเพื่อการบริหารงานโครงการ (E-Granting) สำหรับภาคี',
          department: '',
          lastUpdate: ' 21 กันยายน 2565',
          fileSize: '286.5 MB',
          fileType: 'mp4',
          filePath: '',
          link: 'https://www.youtube.com/watch?v=G8E_MMv7b8w',
          icon: {
            name: 'youtube-play',
            color: '#ee0d0d',
          },
        },
      ],
    },
    {
      title: 'ดาวน์โหลดแบบฟอร์ม ข้อเสนอโครงการ',
      files: [
        {
          id: '',
          no: '1',
          documentName: 'แบบฟอร์มข้อเสนอโครงการประเภทพัฒนา',
          department: '',
          lastUpdate: ' 15 มีนาคม 2565',
          fileSize: '167 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '2',
          documentName: 'แบบฟอร์มข้อเสนอโครงการประเภทวิจัย',
          department: '',
          lastUpdate: ' 15 มีนาคม 2565',
          fileSize: '165 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '3',
          documentName: 'แบบฟอร์มข้อเสนอโครงการประเภทอุปถัมภ์',
          department: '',
          lastUpdate: ' 15 มีนาคม 2565',
          fileSize: '165 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
      ],
    },
    {
      title: 'ดาวน์โหลดแบบฟอร์ม สำนักกฎหมาย',
      files: [
        {
          id: '',
          no: '1',
          documentName: 'หนังสือทวงข้อตกลงคืน (สสส.)',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '16 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '2',
          documentName: 'หนังสือยกเลิกไม่ทำสัญญา (สสส.)',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '16 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '3',
          documentName: 'หนังสือขอยกเลิกไม่ทำข้อตกลง (ผู้รับทุน)',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '21 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '4',
          documentName: 'หนังสือเร่งรัดให้ส่งผลงาน ครั้งที่ 1',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '24 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '5',
          documentName: 'หนังสือเร่งรัดให้ส่งผลงาน ครั้งที่ 2',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '21 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '6',
          documentName: 'หนังสือแจ้งยุติโครงการ',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '21 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '7',
          documentName: 'หนังสือแต่งตั้งผู้รับผิดชอบโครงการ',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '20 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '8',
          documentName: 'หนังสือมอบอำนาจ-สสส',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '19 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
        {
          id: '',
          no: '9',
          documentName: 'ใบสรุปข้อเท็จจริง',
          department: 'สำนักกฎหมาย',
          lastUpdate: ' 3 ธันวาคม 2564',
          fileSize: '29 KB',
          fileType: 'docx',
          filePath: '',
          link: '',
          icon: {
            name: 'file-word-o',
            color: '#0088ff',
          },
        },
      ],
    },
  ],
}

// const data = [
//   {
//     id: '1',
//     documentName: 'แบบฟอร์มข้อเสนอโครงการประเภทพัฒนา',
//     department: '',
//     lastUpdate: ' 15 มีนาคม 2565',
//     fileSize: '167 KB',
//     fileType: 'docx',
//     folder: 'proposalFiles',
//   },
//   {
//     id: '2',
//     documentName: 'แบบฟอร์มข้อเสนอโครงการประเภทวิจัย',
//     department: '',
//     lastUpdate: ' 15 มีนาคม 2565',
//     fileSize: '165 KB',
//     fileType: 'docx',
//     folder: 'proposalFiles',
//   },
//   {
//     id: '3',
//     documentName: 'แบบฟอร์มข้อเสนอโครงการประเภทอุปถัมภ์',
//     department: '',
//     lastUpdate: ' 15 มีนาคม 2565',
//     fileSize: '165 KB',
//     fileType: 'docx',
//     folder: 'proposalFiles',
//   },
// ]

// const data2 = [
//   {
//     id: '1',
//     documentName: 'หนังสือทวงข้อตกลงคืน (สสส.)',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '16 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '2',
//     documentName: 'หนังสือยกเลิกไม่ทำสัญญา (สสส.)',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '16 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '3',
//     documentName: 'หนังสือขอยกเลิกไม่ทำข้อตกลง (ผู้รับทุน)',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '21 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '4',
//     documentName: 'หนังสือเร่งรัดให้ส่งผลงาน ครั้งที่ 1',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '24 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '5',
//     documentName: 'หนังสือเร่งรัดให้ส่งผลงาน ครั้งที่ 2',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '21 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '6',
//     documentName: 'หนังสือแจ้งยุติโครงการ',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '21 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '7',
//     documentName: 'หนังสือแต่งตั้งผู้รับผิดชอบโครงการ',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '20 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '8',
//     documentName: 'หนังสือมอบอำนาจ-สสส',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '19 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
//   {
//     id: '9',
//     documentName: 'ใบสรุปข้อเท็จจริง',
//     department: 'สำนักกฎหมาย',
//     lastUpdate: ' 3 ธันวาคม 2564',
//     fileSize: '29 KB',
//     fileType: 'docx',
//     folder: 'lawFiles',
//   },
// ]

// const data3 = [
//   {
//     id: '1',
//     documentName: 'Quick Guide -สำหรับผู้รับทุน V.1.2',
//     department: '',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '3.3 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '2',
//     documentName: 'Quick Guide -สำหรับนักวิชาการสำนัก V.1.2',
//     department: '',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '3.5 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '3',
//     documentName: 'Quick Guide -ศูนย์สัญญา  V 1.0',
//     department: '',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '981 KB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '4',
//     documentName: 'Quick Guide - สำหรับผู้ทรงคุณวุฒิ V 1.2',
//     department: '',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '1 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '5',
//     documentName: 'Quick Guide - ผู้มีอำนาจอนุมัติ  V 1.0',
//     department: '',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '1.3 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '6',
//     documentName: 'Quick Guide - การจัดการโครงการย่อย V 1.0',
//     department: '',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '4.8 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '7',
//     documentName: 'คู่มือการใช้งานระบบบริหารงานโครงการ(E-Granting) - สำหรับภาคี V.1.3',
//     department: '',
//     lastUpdate: ' 01 กรกฎาคม 2565',
//     fileSize: '6.2 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '8',
//     documentName: 'คู่มือการใช้งานระบบบริหารงานโครงการ(E-Granting) - สำหรับเจ้าหน้าที่ V.1.5',
//     department: '',
//     lastUpdate: ' 04 กรกฎาคม 2565',
//     fileSize: '17.8 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '9',
//     documentName: 'แก้ไขสัญญาในระบบeGranting(งบประมาณ)',
//     department: '',
//     lastUpdate: ' 09 ธันวาคม 2565',
//     fileSize: '845 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '10',
//     documentName: 'แก้ไขสัญญาในระบบeGranting(ระยะเวลา)',
//     department: '',
//     lastUpdate: ' 09 ธันวาคม 2565',
//     fileSize: '678 MB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '11',
//     documentName: 'วิธีการปรับแก้ไขระยะเวลา(ขอแก้ไขสัญญา)_นักวิชาการ',
//     department: '',
//     lastUpdate: ' 13 กุมภาพันธ์ 2566',
//     fileSize: '262 KB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '12',
//     documentName: 'Manual_ฉบับปรับปรุงการใช้ระบบ_update_วันที่_15052566',
//     department: '',
//     lastUpdate: ' 14 มิถุนายน 2566',
//     fileSize: '2945 KB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
//   {
//     id: '13',
//     documentName: 'คู่มือการกดอนุมัติหลายโครงการในระบบ_eGranting',
//     department: '',
//     lastUpdate: ' 14 มิถุนายน 2566',
//     fileSize: '1183 KB',
//     fileType: 'pdf',
//     folder: 'quickGuide',
//   },
// ]

// const data4 = [
//   {
//     id: '1',
//     documentName: '1. ผู้ทรงคุณวุฒิ',
//     department: '',
//     link: 'https://drive.google.com/file/d/1oPqEAsMF485y-jkWMTP4xcMBjC8PQzI6/view?usp=sharing',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '35.6 MB',
//     fileType: 'mp4',
//     folder: '',
//   },
//   {
//     id: '2',
//     documentName: '2. ภาคีผู้รับทุน',
//     department: '',
//     link: 'https://drive.google.com/file/d/1j5VLJRyYn4cN_K5c5EyyJ7HCUCfL0mx5/view?usp=sharing',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '183.9 MB',
//     fileType: 'mp4',
//     folder: '',
//   },
//   {
//     id: '3',
//     documentName: '3. ศูนย์สัญญา',
//     department: '',
//     link: 'https://drive.google.com/file/d/1KKA7ec671HvqUU_Wf_OJ39uAdWop7hGW/view?usp=sharing',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '45.4 MB',
//     fileType: 'mp4',
//     folder: '',
//   },
//   {
//     id: '4',
//     documentName: '4. นักวิชาการ-ผู้ประสาน',
//     department: '',
//     link: 'https://drive.google.com/file/d/1fyhU18hLdDXA8xZBqPaZtiLTKQBuqy9K/view?usp=sharing',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '177.7 MB',
//     fileType: 'mp4',
//     folder: '',
//   },
//   {
//     id: '5',
//     documentName: '5. ผู้มีอำนาจอนุมัติ',
//     department: '',
//     link: 'https://drive.google.com/file/d/1uyfvh9ncMWx51FihAlYgmqKSeItOmK8v/view?usp=sharing',
//     lastUpdate: ' 11 พฤษภาคม 2565',
//     fileSize: '97.7 MB',
//     fileType: 'mp4',
//     folder: '',
//   },
//   {
//     id: '6',
//     documentName: '6. ระบบสารสนเทศเพื่อการบริหารงานโครงการ (E-Granting)',
//     department: '',
//     link: 'https://www.youtube.com/watch?v=G8E_MMv7b8w',
//     lastUpdate: ' 21 กันยายน 2565',
//     fileSize: '549 MB',
//     fileType: 'mp4',
//     folder: '',
//   },
//   {
//     id: '7',
//     documentName: '7. ระบบสารสนเทศเพื่อการบริหารงานโครงการ (E-Granting) สำหรับภาคี',
//     department: '',
//     link: 'https://www.youtube.com/watch?v=G8E_MMv7b8w',
//     lastUpdate: ' 21 กันยายน 2565',
//     fileSize: '286.5 MB',
//     fileType: 'mp4',
//     folder: '',
//   },
// ]

// const data5 = [
//   {
//     id: '1',
//     documentName: 'บุคคลธรรมดา',
//     department: '',
//     lastUpdate: ' 28 กุมภาพันธ์ 2566',
//     fileSize: '13 KB',
//     fileType: 'docx',
//     folder: 'proposalOfdocumentation',
//   },
//   {
//     id: '2',
//     documentName: 'คณะบุคคลหรือห้างหุ้นส่วนที่ไม่ใช่นิติบุคคล',
//     department: '',
//     lastUpdate: ' 28 กุมภาพันธ์ 2566',
//     fileSize: '14 KB',
//     fileType: 'docx',
//     folder: 'proposalOfdocumentation',
//   },
//   {
//     id: '3',
//     documentName: 'บริษัทหรือห้างหุ้นส่วนนิติบุคคล',
//     department: '',
//     lastUpdate: ' 28 กุมภาพันธ์ 2566',
//     fileSize: '14 KB',
//     fileType: 'docx',
//     folder: 'proposalOfdocumentation',
//   },
//   {
//     id: '4',
//     documentName: 'มูลนิธิหรือสมาคม',
//     department: '',
//     lastUpdate: ' 28 กุมภาพันธ์ 2566',
//     fileSize: '14 KB',
//     fileType: 'docx',
//     folder: 'proposalOfdocumentation',
//   },
//   {
//     id: '5',
//     documentName: 'ส่วนราชการหรือหน่วยงานอื่นของรัฐ',
//     department: '',
//     lastUpdate: ' 28 กุมภาพันธ์ 2566',
//     fileSize: '14 KB',
//     fileType: 'docx',
//     folder: 'proposalOfdocumentation',
//   },
// ]
